/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // --- Klaviyo trigger buttons ---
  // Any element with data-klaviyo-trigger opens the Klaviyo form/list
  // given in its data-klaviyo-list-id (set per-market in the
  // "Klaviyo trigger button" block).
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-klaviyo-trigger]');
    if (!trigger) return;

    event.preventDefault();

    var listId = trigger.getAttribute('data-klaviyo-list-id');
    if (!listId) return;

    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', listId]);
  });

  // --- Variant selection validation ---
  // When preselectFirstVariant is off, keep ATC active and show an inline
  // error listing missing options if the user clicks without selecting all options.

  function getSectionForEl(el) {
    return el.closest('[data-section-id]') || document.body;
  }

  function getUnselectedWrappers(section) {
    var unselected = [];
    section.querySelectorAll('[data-option-position]').forEach(function(wrapper) {
      var checked = wrapper.querySelector('input[type="radio"]:checked');
      var hidden  = wrapper.querySelector('input[type="hidden"][data-single-option-selector]');
      var hasValue = checked || (hidden && hidden.value && hidden.value !== '');
      if (!hasValue) unselected.push(wrapper);
    });
    return unselected;
  }

  function showOptionError(wrapper) {
    var nameEl = wrapper.querySelector('.radio__legend__option-name');
    var name = nameEl ? nameEl.textContent.trim() : 'option';

    var errorEl = wrapper.querySelector('.variant-select-error');
    if (!errorEl) {
      errorEl = document.createElement('p');
      errorEl.className = 'variant-select-error';
      var legend = wrapper.querySelector('legend');
      if (legend) {
        legend.after(errorEl);
      } else {
        wrapper.prepend(errorEl);
      }
    }

    errorEl.textContent = 'Please select a ' + name;
    errorEl.removeAttribute('hidden');
  }

  function clearOptionError(wrapper) {
    var errorEl = wrapper.querySelector('.variant-select-error');
    if (errorEl) errorEl.setAttribute('hidden', '');
  }

  function triggerUnselectedErrors(section) {
    var unselected = getUnselectedWrappers(section);
    if (!unselected.length) return false;

    unselected.forEach(function(wrapper) {
      showOptionError(wrapper);
      var radioButtons = wrapper.querySelector('.radio__buttons');
      if (radioButtons) {
        radioButtons.classList.remove('variant-option-shake');
        void radioButtons.offsetWidth;
        radioButtons.classList.add('variant-option-shake');
        radioButtons.addEventListener('animationend', function() {
          radioButtons.classList.remove('variant-option-shake');
        }, { once: true });
      }
    });
    return true;
  }

  // Intercept ATC and Notify Me clicks before theme handlers fire
  document.addEventListener('click', function(e) {
    if (window.theme && window.theme.settings && window.theme.settings.preselectFirstVariant) return;

    var btn = e.target.closest('[data-add-to-cart]');
    var notifyBtn = !btn && e.target.closest('.product-soldout-notification [data-popup-open]');

    if (!btn && !notifyBtn) return;

    var section = getSectionForEl(btn || notifyBtn);
    var hadErrors = triggerUnselectedErrors(section);

    if (hadErrors) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);

  // Clear per-group error as soon as the user selects that option
  document.addEventListener('change', function(e) {
    if (!e.target.matches('[data-single-option-selector]')) return;
    var wrapper = e.target.closest('[data-option-position]');
    if (wrapper) clearOptionError(wrapper);
  });

  // --- Price fallback ---
  // When preselect is off, restore the Liquid-rendered price if theme JS overwrites it to 0,00 before any selection.

  if (!(window.theme && window.theme.settings && window.theme.settings.preselectFirstVariant)) {
    var initialPrices = new Map();

    // Read prices from Liquid-rendered data attribute (immune to JS timing)
    var priceEls = document.querySelectorAll('[data-product-price][data-initial-price]');
    priceEls.forEach(function(el) {
      var val = el.dataset.initialPrice;
      initialPrices.set(el, val);
    });

    function hasAllOptionsSelected(el) {
      var section = el.closest('[data-section-id]') || document.body;
      var wrappers = section.querySelectorAll('[data-option-position]');
      if (wrappers.length === 0) return true; // single-variant product, always selected
      for (var i = 0; i < wrappers.length; i++) {
        var checked = wrappers[i].querySelector('input[type="radio"]:checked');
        var hidden  = wrappers[i].querySelector('input[type="hidden"][data-single-option-selector]');
        var hasValue = checked || (hidden && hidden.value && hidden.value !== '');
        if (!hasValue) return false;
      }
      return true;
    }

    function restoreIfNoVariant(el, savedHtml) {
      if (!hasAllOptionsSelected(el)) {
        el.innerHTML = savedHtml;
      }
    }

    document.addEventListener('DOMContentLoaded', function() {
      initialPrices.forEach(function(html, el) {
        restoreIfNoVariant(el, html);
      });

      initialPrices.forEach(function(html, el) {
        var observer = new MutationObserver(function() {
          observer.disconnect();
          restoreIfNoVariant(el, html);
          observer.observe(el, { childList: true, subtree: true, characterData: true });
        });
        observer.observe(el, { childList: true, subtree: true, characterData: true });
      });
    });
  }

  // --- PLP size/option availability filter fix ---
  // Shopify's filter counts only check if a variant exists, not if it's in stock; hides cards that only match via a sold-out variant.
  (function () {
    function getActiveOptionFilterGroups(container) {
      var form = container.querySelector('[data-collection-filters-form]');
      if (!form) return {};

      // Use the visible label, not the checkbox value (a synthetic group id); group by filter name so same-group values OR together.
      var checked = form.querySelectorAll('input[type="checkbox"][name^="filter.v.option."]:checked, input[type="checkbox"][name^="filter.v.t."]:checked');
      var groups = {};
      checked.forEach(function (input) {
        if (!input.dataset.filterValueLabel) return;
        var key = input.name;
        if (!groups[key]) groups[key] = [];
        groups[key].push(input.dataset.filterValueLabel);
      });
      return groups;
    }

    function applyAvailabilityFilter(grid) {
      var container = grid.closest('.collection__products') || document;
      var groups = getActiveOptionFilterGroups(container);
      var groupKeys = Object.keys(groups);

      grid.querySelectorAll('[data-grid-item]').forEach(function (item) {
        if (!groupKeys.length) {
          item.removeAttribute('data-hidden-unavailable');
          item.style.removeProperty('display');
          return;
        }

        var available = (item.dataset.availableOptionValues || '').split('||').filter(Boolean);
        var matchesAllGroups = groupKeys.every(function (key) {
          // Taxonomy filters are product-level, not a variant option value - just check the product has any purchasable variant.
          if (key.indexOf('filter.v.t.') === 0) {
            return available.length > 0;
          }

          return groups[key].some(function (value) {
            return available.indexOf(value) !== -1;
          });
        });

        if (matchesAllGroups) {
          item.removeAttribute('data-hidden-unavailable');
          item.style.removeProperty('display');
        } else {
          item.setAttribute('data-hidden-unavailable', '');
          item.style.display = 'none';
        }
      });
    }

    // Labels that appear in stock on any currently loaded product card.
    function getAvailableLabels(grid) {
      var labels = {};
      grid.querySelectorAll('[data-grid-item]').forEach(function (item) {
        (item.dataset.availableOptionValues || '').split('||').filter(Boolean).forEach(function (value) {
          labels[value] = true;
        });
      });
      return labels;
    }

    // Marks filter options as sold-out (not just absent); skipped when paginated since we'd only see one page's stock.
    function markSoldOutFilterOptions(grid) {
      if (grid.querySelector('.pagination-custom')) return;

      var container = grid.closest('.collection__products') || document;
      var form = container.querySelector('[data-collection-filters-form]');
      if (!form) return;

      var availableLabels = getAvailableLabels(grid);

      // Excludes taxonomy filters - no reliable way to tell if a specific taxonomy value is sold out.
      form.querySelectorAll('input[type="checkbox"][name^="filter.v.option."]').forEach(function (input) {
        if (input.disabled || input.checked) return;

        var label = input.dataset.filterValueLabel;
        if (!label || availableLabels[label]) return;

        input.disabled = true;
        var listItem = input.closest('.sidebar__item');
        if (listItem) {
          listItem.classList.remove('link--add');
          listItem.classList.add('link--disable');
        }
      });
    }

    function watchGrid(grid) {
      applyAvailabilityFilter(grid);
      markSoldOutFilterOptions(grid);

      var observer = new MutationObserver(function () {
        applyAvailabilityFilter(grid);
        markSoldOutFilterOptions(grid);
      });
      observer.observe(grid, { childList: true, subtree: true });
    }

    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('[data-products-grid]').forEach(watchGrid);
    });
  })();

  // --- Ad products slider ---
  // Builds sections/collection-ad-products.liquid cards from ?featured1-4 or repeated ?featured= params.
  (function () {
    var section = document.querySelector('[data-ad-products]');
    if (!section) return;

    var grid = section.querySelector('[data-ad-products-grid]');
    if (!grid) return;

    var params = new URLSearchParams(window.location.search);
    var handles = [];
    ['featured1', 'featured2', 'featured3', 'featured4'].forEach(function (key) {
      var handle = params.get(key);
      if (handle) handles.push(handle);
    });
    params.getAll('featured').forEach(function (handle) {
      if (handle) handles.push(handle);
    });
    handles = handles.slice(0, 4);

    if (!handles.length) return;

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }

    function formatPrice(cents) {
      if (cents === 0) {
        return (window.theme && window.theme.strings && window.theme.strings.free) || '';
      }
      return Shopify.formatMoney(cents, window.theme.moneyFormat);
    }

    // Pulls the real <quick-add-product> markup (with its quick-add-modal-template)
    // straight from the existing api-product-grid-item section, instead of rebuilding
    // it by hand - so it stays in sync with product-grid-item-new.liquid automatically.
    function fetchQuickAddMarkup(product) {
      return fetch('/products/' + product.handle + '?section_id=api-product-grid-item')
        .then(function (res) { return res.ok ? res.text() : ''; })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var el = doc.querySelector('quick-add-product[data-quick-add-container="' + product.id + '"]');
          return el ? el.outerHTML : '';
        })
        .catch(function () { return ''; });
    }

    function buildCard(product, quickAddHtml) {
      var item = document.createElement('div');
      item.className = 'grid-item product-item ad-product-item';
      item.setAttribute('data-grid-item', '');

      var onSale = product.compare_at_price > product.price;
      var priceInner;

      if (!product.available) {
        var soldOutLabel = (window.theme && window.theme.strings && window.theme.strings.soldOut) || '';
        priceInner = '<span class="sold-out">' + escapeHtml(soldOutLabel) + '</span>';
      } else {
        var fromLabel = (window.theme && window.theme.strings && window.theme.strings.from) || '';
        priceInner = '<span class="new-price">' +
          (product.price_varies ? '<small>' + escapeHtml(fromLabel) + '</small> ' : '') +
          formatPrice(product.price) +
          '</span>';

        if (onSale) {
          priceInner += '<span class="old-price">' + formatPrice(product.compare_at_price) + '</span>';
        }
      }

      // Matches the real grid card's tag-based badge (e.g. _badge_New_In -> "New In").
      var badgeHtml = '';
      var productTags = ',' + (product.tags || []).join(',') + ',';
      var badgeMatch = productTags.match(/,_badge_([^,]+)/);
      if (badgeMatch) {
        var badgeText = badgeMatch[1].replace(/_/g, ' ');
        badgeHtml = '<div class="badges--container"><span class="badge-box">' + escapeHtml(badgeText) + '</span></div>';
      }

      var imageUrl = product.featured_image || (product.images && product.images[0]) || '';
      if (section.dataset.defaultImage === 'model_shot' && product.images && product.images[1]) {
        imageUrl = product.images[1];
      }
      var imageTag = '<div class="product-item__bg image--empty" data-product-image-default></div>';

      if (imageUrl) {
        var separator = imageUrl.indexOf('?') === -1 ? '?' : '&';
        imageTag =
          '<div class="product-item__bg">' +
            '<img src="' + imageUrl + separator + 'width=600" alt="" class="ad-product-item__image fit-cover" loading="lazy">' +
          '</div>';
      }

      // Quick-add is interactive (form/button), so it can't nest inside the card's <a> link.
      item.innerHTML =
        '<a href="' + product.url + '" class="ad-product-item__link">' +
          '<div class="product-item__image plp-image-container">' + imageTag + '</div>' +
          badgeHtml +
        '</a>' +
        '<div class="product-information product-information-card product-item__price__holder">' +
          '<div class="product-item__info">' +
            '<div class="product-item__title-holder">' +
              '<a href="' + product.url + '"><p class="product-item__title">' + escapeHtml(product.title) + '</p></a>' +
              (quickAddHtml || '') +
            '</div>' +
            '<div class="product-item__price__holder">' +
              '<span class="price' + (onSale ? ' sale' : '') + '">' + priceInner + '</span>' +
            '</div>' +
          '</div>' +
        '</div>';

      return item;
    }

    Promise.all(
      handles.map(function (handle) {
        return fetch('/products/' + handle + '.js')
          .then(function (res) { return res.ok ? res.json() : null; })
          .then(function (product) {
            if (!product) return null;
            return fetchQuickAddMarkup(product).then(function (quickAddHtml) {
              return { product: product, quickAddHtml: quickAddHtml };
            });
          })
          .catch(function () { return null; });
      })
    ).then(function (results) {
      var resolved = results.filter(Boolean);
      if (!resolved.length) {
        // Re-hide the section if none of the handles resolved to real products.
        section.setAttribute('hidden', '');
        return;
      }

      var placeholder = grid.querySelector('.ad-products__editor-placeholder');
      if (placeholder) placeholder.remove();

      var cards = resolved.map(function (result) {
        var card = buildCard(result.product, result.quickAddHtml);
        grid.appendChild(card);
        return card;
      });

      section.removeAttribute('hidden');

      var sliderRoot = section.querySelector('grid-slider');
      if (sliderRoot) {
        sliderRoot.dispatchEvent(new CustomEvent('theme:grid-slider:init'));
      }
      
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          cards.forEach(function (card) {
            card.classList.add('ad-product-item--visible');
          });
        });
      });
    });
  })();

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
